var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cta-tile__content",
      style: {
        "background-image":
          "linear-gradient(rgba(0,0,0," +
          _vm.overlayOpacity +
          "), rgba(0,0,0," +
          _vm.overlayOpacity +
          ")), url(" +
          _vm.backgroundImage +
          ")"
      }
    },
    [
      _c("h4", { staticClass: "cta-tile__title" }, [_vm._v(_vm._s(_vm.title))]),
      _c("p", { staticClass: "cta-tile__description" }, [
        _vm._v(_vm._s(_vm.description))
      ]),
      _c(
        "base-button",
        { staticClass: "cta-tile__button", attrs: { href: _vm.btnLink } },
        [_vm._v(_vm._s(_vm.btnText))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }